<li class="list-group-item">
  <div *ngIf="title!=='none'" class="panel panel-default align-position">
    <div class="panel-body">
      <i *ngIf="icon" class="fal {{icon}}"></i>
      <span> {{title | translate:locale.language }}</span>
    </div>

    <div *ngIf="isAdd && selectOption && listSelectOption && listSelectOption.length > 0" style="margin-right: 50px">
      <select class="form-control optgroup" #t (change)="selectOptionUp(t.value)" style="zoom:80% ;  margin-right: 50px" [(ngModel)]="selectOptionDefault">
        <option [ngValue]="null"></option>
        <option *ngFor="let list of listSelectOption" [value]="list.addressType"  translate="">{{list.addressType}}</option>
      </select>
    </div>
    <ng-container *ngIf="!isExchange && isEdit && getParamsText!=='none'" >
      <div [ngClass]="!isEditable ? 'not-allowed opacity-disabled' : '' " *ngIf="isDisabled" (click)="setEdition()" >
        <i tooltip="{{!isEditable ? (errorStatusUpdateText | translate:locale.language) : (getParamsText | translate:locale.language)}}" containerClass="tooltip-no-wrap"
           class="{{getParamsIcon}}" id="{{title + '_fa_edit'}}"></i>
      </div>
      <div *ngIf="!isDisabled" class="align-position">
        <div *ngIf="selectOption && listSelectOption && listSelectOption.length > 0" style="margin-right: 50px">
          <select class="form-control optgroup"  #t (change)="selectOptionUp(t.value)" style="zoom:80% ;  margin-right: 50px" [(ngModel)]="selectOptionDefault">
            <option [ngValue]="null"></option>
            <option *ngFor="let list of listSelectOption" [value]="list.addressType"  translate="">{{list.addressType}}</option>
          </select>
        </div>
        <div (click)="undoEdition()" ><i tooltip="{{'GENERIC_UNDO' | translate:locale.language}}" class="fal fa-undo" id="{{title + '_fa_undo'}}"></i></div>
        <div [ngClass]="form.invalid || form.pristine ? 'not-allowed' : '' " (click)="saveEdition()" >
          <i tooltip="{{'GENERIC_SAVE' | translate:locale.language}}" class="fal fa-save" id="{{title + '_fa_save'}}"></i>
        </div>
      </div>
    </ng-container>

    <div *ngIf="infoBull" tooltip="{{ infoBull | translate:locale.language}}" class="align-position">
      <i class="fal fa-info"></i>
    </div>
  </div>
  <span [class]="form.get(['orderCountThisDay'])?.value > 15 ? 'row' : ''">
  <span [class]="form.get(['orderCountThisDay'])?.value > 15 ? 'col-sm-10' : ''" >
  <storever-dynamic-form
                         [config]="config"
                         [form]="form"
                         [isLoadingBlock]="isLoadingBlock"
                         [isAdd]="isAdd"
                         [isEdit]="isEdit"
                         [isExchange]="isExchange"
                         [orderType]="orderType"
                         [stylingClass]="stylingClass"></storever-dynamic-form>
    </span>
    <span class="col-sm-2" [class]="isAdd ? 'order-counter-add' : 'order-counter-add'"
          *ngIf="form.get(['orderCountThisDay'])?.value > 15">
                <i class="fad fa-exclamation-triangle fa-2x" style="color:red"></i>
                {{'ORDERS_LIST_ORDER_COUNTER' | translate:locale.language}}
                {{ nextSuggestedDate ? nextSuggestedDate : form.get(['expeditionDate'])?.value | date: 'dd/MM/yyyy' }}
    </span>
    </span>
</li>

<!-- DEBUG -->
<div *ngIf="false" style="display:flex;">
  (2)element-group:
    <pre style="flex:1;word-break:break-word;line-height:2;">playerInfo: {{form.getRawValue()|json}}</pre>
<!--  <div style="flex:1;word-break:break-word;line-height:2;">{{getInvalidControls(form)}}</div>-->
</div>
